import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import {
  accreditationApi,
  businessApi,
  assetApi,
  blockApi,
  bookingApi,
  clientApi,
  companyApi,
  driverApi,
  driverProfileApi,
  driverPayoutApi,
  networkApi,
  paymentApi,
  tripApi,
  qrApi,
  ratingApi,
  reportingApi,
  reportApi,
  documentApi,
  typeaheadApi,
  userAccountApi,
  userAccountProfileApi,
  profileApi,
  operatorApi,
  accountApi,
  jobRatingApi,
  paymentMethodApi,
  bankAccountApi,
  applicationApi,
  resourceApi,
  recommendApi,
  notificationApi,
  externalSupplierApi,
  bookingOfferApi,
  payInvoiceApi,
  vehicleGuestApi,
  addOnApi,
  onboardingApi,
  systemApi,
  linksAndDocumentsApi,
  termsAndConditionsApi,
  configVehicleApi,
  contentApi,
  vehicleTypeApi,
  subscriptionPlansApi,
  marketingApi,
} from "../apis";
import type { AppDispatch, RootState } from "../store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppResetApi = () => {
  const dispatch = useAppDispatch();
  return () => {
    dispatch(profileApi.util.invalidateTags(["Profile"]));
    dispatch(operatorApi.util.invalidateTags(["Operators"]));
    dispatch(accountApi.util.invalidateTags(["Account"]));
    dispatch(businessApi.util.resetApiState());
    dispatch(tripApi.util.resetApiState());
    dispatch(accreditationApi.util.resetApiState());
    dispatch(blockApi.util.resetApiState());
    dispatch(bookingApi.util.resetApiState());
    dispatch(clientApi.util.resetApiState());
    dispatch(companyApi.util.resetApiState());
    dispatch(assetApi.util.resetApiState());
    dispatch(driverApi.util.resetApiState());
    dispatch(driverProfileApi.util.resetApiState());
    dispatch(driverPayoutApi.util.resetApiState());
    dispatch(networkApi.util.resetApiState());
    dispatch(paymentApi.util.resetApiState());
    dispatch(qrApi.util.resetApiState());
    dispatch(ratingApi.util.resetApiState());
    dispatch(reportingApi.util.resetApiState());
    dispatch(reportApi.util.resetApiState());
    dispatch(documentApi.util.resetApiState());
    dispatch(typeaheadApi.util.resetApiState());
    dispatch(userAccountApi.util.resetApiState());
    dispatch(userAccountProfileApi.util.resetApiState());
    dispatch(jobRatingApi.util.resetApiState());
    dispatch(paymentMethodApi.util.resetApiState());
    dispatch(bankAccountApi.util.resetApiState());
    dispatch(applicationApi.util.resetApiState());
    // User/operator-specific APIs that need reset on logout
    dispatch(resourceApi.util.resetApiState());
    dispatch(recommendApi.util.resetApiState());
    dispatch(notificationApi.util.resetApiState());
    dispatch(externalSupplierApi.util.resetApiState());
    dispatch(bookingOfferApi.util.resetApiState());
    dispatch(payInvoiceApi.util.resetApiState());
    dispatch(vehicleGuestApi.util.resetApiState());
    dispatch(addOnApi.util.resetApiState());
    dispatch(onboardingApi.util.resetApiState());
    // Config/system APIs
    dispatch(systemApi.util.resetApiState());
    dispatch(linksAndDocumentsApi.util.resetApiState());
    dispatch(termsAndConditionsApi.util.resetApiState());
    dispatch(configVehicleApi.util.resetApiState());
    dispatch(contentApi.util.resetApiState());
    dispatch(vehicleTypeApi.util.resetApiState());
    dispatch(subscriptionPlansApi.util.resetApiState());
    dispatch(marketingApi.util.resetApiState());
  };
};
